/**
 * Returns the Prismic UID for the english version of the page.
 * Falls back on the current page's uid (if present)
 * or the Prismic document type (e.g. 404_page)
 * @param page The page's full data
 */
export const getEnglishUID = (page: any = {}): string => {
    const en = 'en-us';
    if (page.lang !== en && page.alternate_languages) {
        const enPage = page.alternate_languages.find((p: any) => p.lang === en);
        if (enPage && enPage.uid) {
            return enPage.uid;
        }
    }
    return page.uid || page.type;
};
